import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchTreatment } from 'src/bff';
import { SelectExtendedList } from './CarlineSelect';
import { SelectExtended } from './SelectExtended';
import { TOKEN_LEADS_COMERCIALES, TOKEN_LEADS_TURISMOS } from 'src/globals';
import { useIsComerciales } from 'src/feature-app/hooks';

export const Trato = () => {
    const [options, setOptions] = useState<SelectExtendedList[]>([]);
    const dispatch = useDispatch();
    const isComerciales = useIsComerciales();

    useEffect(() => {
        const getTreatment = async () => {
            const response = await fetchTreatment(isComerciales ? TOKEN_LEADS_COMERCIALES : TOKEN_LEADS_TURISMOS);
            const options: SelectExtendedList[] = response.content.map((att, indx) => ({ name: att.attributes[1].value, code: att.attributes[0].value, key: String(indx) }));
            setOptions(options);
            dispatch({ type: 'UPDATE_FIELDS', payload: { trato: options[0].name } });
        };
        getTreatment();
    }, []);

    const handleChange = (event: React.SyntheticEvent) => {
        dispatch({ type: 'UPDATE_FIELDS', payload: { trato: event.currentTarget.value } });
    };

    return (
        <SelectExtended options={options} name="trato" label="Trato" isRequired handleChange={handleChange} onClick={() => { }} />
    );
};
